import { AppNames } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { CreativesList } from './CreativesList/CreativesList';

export const CreativesListPage = () => {
  const { t } = useTranslation();

  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'create-creative-button',
      href: '/aqua/creatives/create',
      label: t('Create New Creative'),
      showAsActionButton: true,
    },
  ];

  return (
    <PageHeader
      render={() => <HeaderActions actions={actions} />}
      titlePrefix={AppNames.OpenXSelect}
      title={t('Creatives List')}
    >
      <CreativesList />
    </PageHeader>
  );
};
